// 接口 - 客服管理
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 通话数据统计 - 列表
export function getCallInRecordList(params){
  return post(`${baseApi}/cusServiceWiringData/list`, params);
}
// 通话数据统计 - 客服选项
export function getCallinSeatOptions(params){
  return get(`${baseApi}/cusServiceWiringData/getSeatList`, params);
}


// 客服名称 - 选项
export const getKfNameOptions = (params) => get(`${baseApi}/jobOrder/seatList`, params);
// 客服实时状态 - 列表
export const getImmediateStatusList = (params) => post(`${baseApi}/jobOrder/seatStatusQuery`, params);
// 通话录音查询 - 列表
export const getCtrList = (params) => post(`${baseApi}/jobOrder/queryCallRecord`, params);
